import type { FaireThemeEntity } from "../../entity_types/theme";

export const the_organic_apothecary: FaireThemeEntity = {
  token: "the-organic-apothecary",
  type: "theme",
  name: "The Organic Apothecary",
  description: "A curated collection of therapeutic-grade remedies and essential oil blends designed to support holistic health for your customers.",
  teaser: "Elsie Rose LLC operates as a pop-up store with a strong preference for natural ingredients, small-batch artisanal goods, and organic wellness products. Your distinctive interests include healing salves, aromatherapy mists, and essential oils.",
  detail: "The additional_context shows a consistent ordering pattern of Rowe Casa Organics products, including the Focus Support essential oil blend and the organic Hair Spritz.",
  bgColor: "#FDE8D0",
  tileBgColor: "#4a6b36",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_7cmrcr22c8",
    "p_xvfa5hz8qr",
    "p_v9vh5q5drf",
    "p_6lbg51g67p",
    "p_7pk9c8sx2p",
    "p_5tdzyzi6xu",
    "p_7ykdyk3bm3",
    "p_x965pxhqkh",
    "p_7kdbzz3rsz",
    "p_kzyuf5tx9c",
    "p_cjtkaggzkh",
    "p_8w6akdvjq7",
    "p_j63pst3br2",
    "p_vyewykrd4m",
    "p_eay9k97q29",
    "p_eqc69ads6t",
    "p_7f8f4ym8gh",
    "p_msfpthtfz9",
    "p_usv4xb8vw4",
    "p_df9jt0hwsn",
    "p_pwb943judh",
    "p_4k5tdmn3zz",
    "p_9cyuacbxek",
    "p_22atpf5sth",
    "p_yrjy3wmgqk",
    "p_tcx525mmdk",
    "p_83wswydtu4",
    "p_25xbioun8c",
    "p_n9k96a759r",
    "p_cv7af574",
    "p_rg3pguandd",
    "p_8zkcdxa49m",
    "p_7637hjdunx",
    "p_stv9bgn6cz",
    "p_9x43x8wn92",
    "p_gb5jbtna5u",
    "p_cqksv5htvp",
    "p_8f3u3z3x67",
    "p_daghvh57d5",
    "p_dc7y49x3v4",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
